export const contactIntroSteps = [
  {
    element: 'h3',
    intro: 'Contact support is where you can submit your questions or thoughts to the WordFlight Customer Support team. The Customer Support team will get back to you with a response as soon as they can!'
  },
  {
    element: '#nameField',
    intro: 'Click here to fill in the text field with your first and last name.'
  },
  {
    element: '#topicField',
    intro: 'Select a topic from the dropdown.'
  },
  {
    element: '#messageField',
    intro: 'Click here to fill in the text field with your question or thoughts. Please provide as much detail and information as you can so that the Customer Support team can best help.'
  },
  {
    element: '#followUpField',
    intro: 'Select either Email or Phone and fill in the corresponding text field with your contact information for follow up.'
  },
  {
    element: '#sendButton',
    intro: 'Click here to send your form to the Customer Support Team. They will get back to you with a response as soon as they can!'
  }
];